<template>
  <ExternalQueryList
      headline="Topics"
      endpoint="/api/v2/content-topics"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentTopic => $router.push(getUrl(contentTopic))"
  >
    <template v-slot:default="{ row: contentTopic }">
      <td>
        <router-link :to="getUrl(contentTopic)">
          {{ contentTopic.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ contentTopic.attributes.publish_at | datetime }}
      </td>

      <td>
        {{ contentTopic.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/topics/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 9, text: 'Name'},
        {width: 4, text: 'Publish At'},
        {width: 7, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentTopic) {
      return '/portals/' + this.portal.id + '/content/topics/' + contentTopic.id + '/edit'
    }
  }
}
</script>
